import axios from 'axios';
const instance = axios.create({ withCredentials: true });

const isAxiosError = axios.isAxiosError;
export {
    isAxiosError,
}

export default instance;
